<template>
	<div class="footer">
		<el-row>
			<el-col :span="5" class="item1">&nbsp;</el-col>
			<el-col :span="14" class="item1">
				<home-route-two v-if="this.$route.path.indexOf('home') == -1"></home-route-two>
				<div v-else>&nbsp;</div>
			</el-col>
			<el-col :span="5" class="item3">&nbsp;</el-col>
		</el-row>
	</div>
</template>

<script>
import { strictEqual } from 'assert';
import dayjs from 'dayjs';
import HomeRouteTwo from '../../FacilityBim/HomeRouteTwo.vue';
import config from '@/api/config';
export default {
	data() {
		return {
			weatherWenzi: '',
			wendu: '',
			date: '',
			week: '',
			dateTime: '',
			timer: null,

			backBut: this.$store.state.backBut
		};
	},
	computed: {
		locale() {
			if (location.host.indexOf('local') !== -1 || location.host.indexOf('192.168') !== -1) {
				return true;
			} else {
				return false;
			}
		}
	},
	components: { HomeRouteTwo },
	created() {
		this.timer = null;
		this.dateTime = dayjs(new Date()).format('HH:mm:ss');
		this.timer = setInterval(() => {
			this.dateTime = dayjs(new Date()).format('HH:mm:ss');
		}, 1000);
	},
	mounted() {
		this.weather();
		this.getDate();
		console.log(this.backBut);
	},
	methods: {
		//获取天气
		weather() {
			//加载天气查询插件
			AMap.plugin('AMap.Weather', () => {
				//创建天气查询实例
				var weather = new AMap.Weather();
				//执行实时天气信息查询
				weather.getLive('诸暨市', (err, data) => {
					this.wendu = data.temperature;
					this.weatherWenzi = data.weather;
				});
			});
		},
		//获取时间 （月，日） 星期
		getDate() {
			this.date = dayjs(new Date()).format('MM月DD日');
			let obj = {
				1: '一',
				2: '二',
				3: '三',
				4: '四',
				5: '五',
				6: '六',
				7: '日'
			};

			this.week = obj[dayjs().day()];
		},
		//跳转首页
		getHome() {
			this.$router.push('/layout');
		},
		//返回首页
		loginOut() {
			this.$router.push('/login');
		},
		swagger() {
			window.open(`${config.host}/doc.html#/home`);
		},
		// 返回
		backClick() {
			window.location.href = 'https://sz.deqing.gov.cn:8085/web/#/navigation';
		}
	},
	destroyed() {
		clearInterval(this.timer);
	}
};
</script>
<style lang="scss" scoped>
.backClass {
	margin-left: 20px;
	a {
		line-height: 100%;
		color: #fff;
		text-decoration: none;
	}
}

.footer {
	width: 100%;
	height: 76px;
	background: url('~@/assets/image/layout/footer.png') no-repeat;
	background-size: 100% 100%;
	// line-height: 90px;
	position: absolute;
	bottom: 0;
	z-index: 99;
}
.item2 {
	font-family: YouSheBiaoTiHei;
	font-size: 36px;
	color: white;
	text-align: left;
	line-height: 90px;
	display: flex;
	align-items: center;
}
.tianqi {
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	line-height: 20px;
	// height: 104px;
	// line-height: 25px;
	// box-sizing: border-box;
	// padding-top: 15px;
	// width: 60px;
}
.img2 {
	width: 20px;
	height: 20px;
	margin-left: 30px;
}

.imgUser {
	width: 40px;
	height: 40px;
	margin-left: 30px;
}
::v-deep .el-badge__content {
	background: transparent;
	top: 16px;
}
</style>
